export default __webpack_public_path__ + "94deb46e57ddae56d8d395f9f8738a2e.png";